import 'pepsico-ds/css'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

// Base path is driven by VITE_CCT_APP_BASE_PATH
// '/'     → standalone: localhost:3000/journey
// '/cct'  → shell mock: localhost:3000/cct/journey
const basePath = import.meta.env.VITE_CCT_APP_BASE_PATH || '/'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App shellActive={false} path={basePath} darkTheme={false} market={'MX'} />
  </React.StrictMode>
)
